import styled from 'styled-components';
import { PrimaryButton, BUTTON_SIZES } from 'ui/button';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { spacing } from 'ui/theme';
import { ModalCarbonCopyText } from './ModalCarbonCopyText';

export const TEXT = {
  ID: 'resend-message-modal',
  CONFIRM: 'Resend message',
  HEADER: 'Resend message?',
};

const P = styled.p`
  margin-bottom: ${spacing.plusHalf};
`;

export const warningText = (email: string): string =>
  `Are you sure that you want to resend this email to ${email}? We’ll resend it using the exact content shown on this page (without updating user profile, data feed, or Catalog data).`;

type Props = {
  ccText: string;
  bccText: string;
  closeModal: () => void;
  onConfirm: () => void;
  recipient: string;
};

export const ResendMessageModal = ({
  bccText,
  ccText,
  closeModal,
  onConfirm,
  recipient,
}: Props) => (
  <Modal
    id={TEXT.ID}
    isModalOpen={true}
    onClose={closeModal}
    size={MODAL_SIZES.SMALL}
    variant={MODAL_VARIANTS.WARNING}
  >
    <ModalHeader>{TEXT.HEADER}</ModalHeader>
    <ModalBody>
      <P>{warningText(recipient)}</P>
      <ModalCarbonCopyText ccText={ccText} bccText={bccText} />
    </ModalBody>
    <ModalFooter>
      <PrimaryButton size={BUTTON_SIZES.LARGE} onClick={onConfirm}>
        {TEXT.CONFIRM}
      </PrimaryButton>
    </ModalFooter>
  </Modal>
);
